import { render, staticRenderFns } from "./make-box.vue?vue&type=template&id=338cd452&scoped=true"
import script from "./make-box.vue?vue&type=script&lang=js"
export * from "./make-box.vue?vue&type=script&lang=js"
import style0 from "./make-box.vue?vue&type=style&index=0&id=338cd452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338cd452",
  null
  
)

export default component.exports